/**
 * Boost Commerce Cart Yardage Display Fix
 * Converts unit quantities to yard display in Boost side cart
 */

(function() {
  'use strict';

  const CONFIG = {
    yardsToUnitsMultiplier: 2, // 1 unit = 0.5 yards
  };

  // Cache cart data
  let cartData = null;

  /**
   * Fetch cart data from Shopify API
   */
  async function fetchCartData() {
    try {
      const response = await fetch('/cart.js');
      cartData = await response.json();
      console.log('[Boost Yardage] Fetched cart data:', cartData);
      return cartData;
    } catch (error) {
      console.error('[Boost Yardage] Error fetching cart:', error);
      return null;
    }
  }

  /**
   * Check if item has Yardage property by index (items should be in same order)
   */
  function hasYardageProperty(item, index) {
    if (!cartData || !cartData.items || !cartData.items[index]) {
      console.log('[Boost Yardage] No cart data for index', index);
      return false;
    }

    const cartItem = cartData.items[index];

    // Check if item has Yardage property (same logic as main cart)
    const hasYardage = cartItem.properties && cartItem.properties.Yardage != null && cartItem.properties.Yardage !== '';

    console.log('[Boost Yardage] Item', index, '-', cartItem.product_title, '- has Yardage:', hasYardage, cartItem.properties);

    return hasYardage;
  }

  /**
   * Convert a cart item's quantity display to yards
   */
  function convertItemToYards(item, index) {
    const quantityInput = item.querySelector('.boost-sd__quantity-input');

    if (!quantityInput || quantityInput.hasAttribute('data-yards-converted')) {
      return; // Already converted or not found
    }

    // ONLY convert if this item has a Yardage property
    if (!hasYardageProperty(item, index)) {
      console.log('[Boost Yardage] Skipping item', index, 'without Yardage property');
      return;
    }

    console.log('[Boost Yardage] Converting item', index, 'with Yardage property');

    const units = parseInt(quantityInput.value) || 0;
    const yards = units / CONFIG.yardsToUnitsMultiplier;
    const yardText = yards === 1 ? 'yard' : 'yards';

    // Mark as converted
    quantityInput.setAttribute('data-yards-converted', 'true');
    quantityInput.setAttribute('data-original-value', units);

    // Create wrapper for number + label to keep them together
    const yardsWrapper = document.createElement('div');
    yardsWrapper.className = 'boost-yards-wrapper';
    yardsWrapper.style.cssText = 'display: inline-flex; flex-direction: column; align-items: center;';

    // Create yards display - JUST the number (vertically centered)
    const yardsDisplay = document.createElement('div');
    yardsDisplay.className = 'boost-yards-display';
    yardsDisplay.style.cssText = 'display: flex; align-items: center; justify-content: center; min-width: 50px; height: 32px; font-weight: 500; font-size: 14px;';
    yardsDisplay.textContent = yards;
    yardsDisplay.setAttribute('data-units', units);

    // Create "yards" text directly underneath
    const yardsLabel = document.createElement('div');
    yardsLabel.className = 'boost-yards-label';
    yardsLabel.style.cssText = 'font-size: 11px; color: #666; margin-top: 6px; white-space: nowrap;';
    yardsLabel.textContent = yardText;

    // Add number and label to wrapper
    yardsWrapper.appendChild(yardsDisplay);
    yardsWrapper.appendChild(yardsLabel);

    // Hide the original input
    quantityInput.style.display = 'none';

    // Insert wrapper after the input
    quantityInput.parentNode.insertBefore(yardsWrapper, quantityInput.nextSibling);

    // Convert price to per-yard display
    const priceWrapper = item.querySelector('.boost-sd__cart-item-quantity-price');
    if (priceWrapper && !priceWrapper.hasAttribute('data-price-converted')) {
      // Extract the original price from any span
      const priceText = priceWrapper.textContent;
      const priceMatch = priceText.match(/\$?([\d,]+\.?\d*)/);

      if (priceMatch) {
        const unitPrice = parseFloat(priceMatch[1].replace(/,/g, ''));
        const yardPrice = unitPrice * CONFIG.yardsToUnitsMultiplier;

        // Clear the wrapper and create clean price display
        priceWrapper.innerHTML = `
          <span style="margin-right: 4px;">×</span>
          <span style="white-space: nowrap;">$${yardPrice.toFixed(2)}/yard</span>
        `;

        // Style the wrapper for horizontal layout
        priceWrapper.style.cssText = 'display: flex; align-items: center; font-size: 14px;';

        priceWrapper.setAttribute('data-price-converted', 'true');
        priceWrapper.setAttribute('data-original-price', unitPrice);

        console.log('[Boost Yardage] Converted price from', `$${unitPrice}`, 'to', `$${yardPrice}/yard`);
      }
    }

    console.log('[Boost Yardage] Converted', units, 'units to', yards, 'yards');

    // Hide +/- buttons to prevent quantity changes in Boost cart
    // Users must edit quantities on main cart page where Yardage property updates correctly

    // Hide ALL button wrappers and buttons in this cart item
    const allButtonWrappers = item.querySelectorAll('.boost-sd__quantity-btn-wrapper');
    const allButtons = item.querySelectorAll('button.boost-sd__button--as-quantity, .boost-sd__button');

    allButtonWrappers.forEach(wrapper => {
      // Don't hide the outer wrapper (it contains our yards display)
      // Only hide if it contains a button
      if (wrapper.querySelector('button')) {
        wrapper.style.display = 'none !important';
      }
    });

    allButtons.forEach(btn => {
      btn.style.display = 'none';
      btn.style.visibility = 'hidden';
      btn.style.pointerEvents = 'none';
    });

    // Add "Edit" link
    const editLink = document.createElement('a');
    editLink.href = '/cart';
    editLink.className = 'boost-edit-in-cart-link';
    editLink.style.cssText = 'display: inline-block; font-size: 12px; color: #2196F3; margin-top: 6px; text-decoration: underline; cursor: pointer;';
    editLink.textContent = 'Edit';
    editLink.onclick = function(e) {
      e.preventDefault();
      window.location.href = '/cart';
    };
    yardsWrapper.appendChild(editLink);

    console.log('[Boost Yardage] Quantity controls hidden - link to cart added');
  }

  /**
   * Convert all items in the Boost cart
   */
  async function convertBoostCart() {
    const cartItems = document.querySelectorAll('.boost-sd__cart-item');

    if (cartItems.length === 0) return;

    console.log('[Boost Yardage] Found', cartItems.length, 'cart items');

    // Fetch cart data first to check properties
    await fetchCartData();

    // Convert items with index for matching
    cartItems.forEach((item, index) => {
      convertItemToYards(item, index);
    });
  }

  /**
   * Watch for Boost cart to open/update
   */
  function watchBoostCart() {
    const observer = new MutationObserver(function(mutations) {
      // Check if Boost cart is visible
      const boostCart = document.querySelector('.boost-sd__modal[aria-modal="true"]');

      if (boostCart && boostCart.style.display !== 'none') {
        convertBoostCart();
      }
    });

    // Observe the body for Boost cart appearing
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-modal', 'style']
    });

    // Also try converting immediately in case cart is already open
    convertBoostCart();

    console.log('[Boost Yardage] Monitoring for Boost cart...');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchBoostCart);
  } else {
    watchBoostCart();
  }

})();
